import { createFileRoute } from "@tanstack/react-router";
import { LegalPage, legalHead } from "@/components/LegalPage";
import { LegacyPolicyBody } from "@/components/LegacyPolicyBody";
import { legacyPolicies } from "@/data/legacy-policies";

export const Route = createFileRoute("/csr-policy")({
  head: () => {
    const head = legalHead({
      title: "CSR Policy | Preserve Earth",
      description:
        "Preserve Earth's corporate social responsibility approach: responsible handling, secure destruction and material recovery for UK businesses.",
      path: "/csr-policy",
      crumbName: "CSR Policy",
    });
    return { ...head, meta: [...head.meta, { name: "robots", content: "index, follow" }] };
  },
  component: CsrPage,
});

function CsrPage() {
  return (
    <LegalPage
      crumb={{ name: "CSR Policy", path: "/csr-policy" }}
      showPolicyContact={false}
      intro={<LegacyPolicyBody blocks={legacyPolicies.csr} />}
    />
  );
}
